<template>
  <div class="about-us">
    <!-- About Us Header with Background Image -->
    <section class="about-header text-center mt-0" style="background: url('/images/insidegym8.jpg') no-repeat center center; background-size: cover; padding: 50px 0; color: #fff;">
      <h1 class="display-4 font-weight-bold">OUR STORY</h1>
      <!-- <p class="lead">Soldiers Gym aims to bring ‘next-generation fitness’ with top-notch specialized workout facilities and training programs for all members.</p> -->
    </section>

    <!-- Content Section with Image on the Left -->
    <section class="about-content container mt-5">
      <div class="row align-items-center">
        <div class="col-md-4 text-center">
          <img
            src="/images/insidegym1.jpg"
            alt="Soldier's Gym"
            class="img-fluid  shadow-lg"
          
          />
        </div>
        <div class="col-md-8">
          <p class="lead">
            Soldiers Gym is located in the heart of Attibele, designed to provide the best fitness experience. Our gym is equipped with state-of-the-art facilities to offer progressive physical training and resistance formats. We aim to deliver world-class services that cater to all your fitness goals.
          </p>
          <p class="lead">
            Widely regarded as one of India’s premier fitness destinations, Soldier's Gym is more than just a gym; it’s a lifestyle. Our mission is to offer the best fitness experience, under the supervision of highly qualified trainers, for a diverse set of fitness goals.
          </p>
          <p class="lead">
            At Soldier's Gym, our dedicated and passionate team of trainers is what makes us stand out. They are highly trained, experienced, and truly care about your success. They not only guide you with workout routines but also motivate and support you throughout your fitness journey.
          </p>
        </div>
      </div>
    </section>

    

    <!-- Call to Action Section -->
    <section class="cta-section text-center mt-5" style="background-color: #fdb913; padding: 40px 0;">
      <h2 class="font-weight-bold">Ready to Start Your Fitness Journey?</h2>
      <p class="lead">Join Soldier's Gym today and take the first step toward achieving your fitness goals.</p>
      <!-- <button class="btn btn-dark btn-lg">Sign Up Now</button> -->
    </section>

    <!-- Testimonials Section -->
    <section class="testimonials-section container mt-5 text-center">
      <h2 class="font-weight-bold text-warning">What Our Members Say</h2>
      <div class="row">
        <div class="col-md-4">
          <div class="testimonial">
            <p class="lead">"Soldier's Gym changed my life! The trainers are amazing and the community is so supportive."</p>
            <p>- Dr.Pavithra B</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="testimonial">
            <p class="lead">"I’ve never felt more motivated to work out. The facilities are top-notch!"</p>
            <p>- Babu</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="testimonial">
            <p class="lead">"A great place to build strength, fitness, and confidence. Highly recommend!"</p>
            <p>- Mithrakshi Samiha </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'AboutUs',
};
</script>

<style scoped>
/* About Us Section Styling */
.about-header h1 {
  font-size: 3rem;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}

.about-header p {
  font-size: 1.25rem;
  color: #fff;
}

.about-content img {
  border: 5px solid #f2b705;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  margin-bottom: 30px;
}

.about-content p {
  font-size: 1.15rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
}

.services-section .card {
  border: none;
}

.services-section .card-title {
  font-size: 1.25rem;
  font-weight: bold;
}

.cta-section h2 {
  color: #fff;
}

.cta-section .btn {
  font-size: 1.2rem;
  padding: 12px 30px;
}

.testimonials-section .testimonial {
  background-color: #f7f7f7;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.testimonials-section .lead {
  font-size: 1.1rem;
  font-style: italic;
}

.testimonials-section p {
  font-size: 1rem;
  font-weight: bold;
}

/* Responsive Design */
@media (max-width: 767px) {
  .about-header h1 {
    font-size: 2rem;
  }

  .about-content .row {
    text-align: center;
  }

  .about-content img {
    max-width: 200px;
    margin-bottom: 20px;
  }
}
</style>
